import { UserLanguage } from './user-language'
import { UserTimezone } from './user-timezone'

import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'
import { AccountWelcomeButton } from '../account/account-settings/forms/welcome-show-update-modal'
import { MultipleSwitch } from '../multiple-switch'
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness'

interface ISettingsGeneralProps {
  isScanner: boolean
}

const SettingsGeneral = ({ isScanner }: ISettingsGeneralProps) => {
  const classes = useStyles()

  return (
    <div className={`${classes.itemBorder} ${classes.settingsItemWrapper}`}>
      <h4 className={classes.itemSubtitle}>
        <HelperWrapper t="user-profile-settings-general-title" ns={ETranslationNs.UserProfile} />
      </h4>
      <div className={classes.settingsItems}>
        <div className={classes.settingsItem}>
          <UserTimezone />
        </div>
        <div className={classes.settingsItem}>
          <UserLanguage />
        </div>
        {!isScanner && (
          <div className={classes.settingsItem}>
            <AccountWelcomeButton />
          </div>
        )}
        {/* <div className={classes.settingsItem}>я
          <SettingsDropdown text="Report a bug" icon={<CommentaryIcon />} />
        </div> */}
        <div className={classes.settingsItem}>
          <div className={classes.themeChoseBlock}>
            <div className={classes.themeBlock}>
              <SettingsBrightnessIcon />
              <HelperWrapper t="theme-switch-label" ns={ETranslationNs.UserProfile} />
            </div>

            <MultipleSwitch />
          </div>
        </div>
      </div>
    </div>
  )
}

export { SettingsGeneral }
